// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"ef0ad07f","360":"ef0ad07f"}[chunkId] + ".chunk.css";
};